import {
    Button,
    useMediaQuery
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import clo_login from "../../images/clo_login.jpg";
import "./LoginPage.scss";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
        // backgroundImage: `url(${clo_login})`,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function LoginCLO() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    return (
        <Button
            className="buttons"
            component={Link}
            to="/afterLoginCLO"
            variant="contained"
            // color="primary"
            style={{
                backgroundImage: `url(${clo_login})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                height: "100vh",
                width: "100%",
            }}
        ></Button>
    );
}
export default LoginCLO;
